import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import IconStar from "../../../../../../assets/images/svg/star.svg";
import { starColors } from "../../../../pages/shared/CIVIC/helpers";
import {
  getCivic,
  getTopClinicalEvidence,
} from "../../../../state/selectors/Civic.selectors";
import style from "./civicCard.module.scss";

const CIVICCard = ({ card, civicData, topClinicalEvidence }) => {
  const clinicalEvidence = topClinicalEvidence[0] || null;
  const calcColor = () => {
    if (topClinicalEvidence && topClinicalEvidence.length > 0) {
      return starColors[topClinicalEvidence[0].rating];
    }
    return null;
  };

  const getRatingStars = () => {
    const stars = [];
    const rating = clinicalEvidence?.rating || 0;
    for (let i = 0; i < rating; i++) {
      const color = starColors[rating];
      stars.push(<IconStar key={i} style={{ color }} className={style.icon} />);
    }
    return stars;
  };

  return (
    <CardWrapper {...card} isDisabled={!civicData} color={calcColor()}>
      {clinicalEvidence ? (
        <>
          <div className="tw-mr-2">{getRatingStars()}</div>
          <div>
            <b data-testid="civic-card-disease">{clinicalEvidence.disease}</b>
          </div>
        </>
      ) : null}
    </CardWrapper>
  );
};

CIVICCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  civicData: PropTypes.arrayOf(PropTypes.shape({})),
  topClinicalEvidence: PropTypes.arrayOf(
    PropTypes.shape({ disease: PropTypes.string, rating: PropTypes.string })
  ),
};

CIVICCard.defaultProps = {
  civicData: [],
  topClinicalEvidence: [],
};

const mapStateToProps = (state) => ({
  civicData: getCivic(state),
  topClinicalEvidence: getTopClinicalEvidence(state),
});

export default connect(mapStateToProps)(CIVICCard);
